import ExploreMixin from '@/mixins/ExploreMixin'

export default {
  name: 'Compete',
  template: '#scouting-template',
  data () {
    return {
      modalActive: false,
      levels: ['ranked', 'mastery', 'history'],
      modalInfo: 1,
      detailLevel: 1,
      direction: 'next'
    }
  },
  mixins: [ExploreMixin],
  methods: {
    prev () {
      this.direction = 'prev'
      if (this.detailLevel === 0) {
        this.detailLevel = this.levels.length - 1
      } else {
        this.detailLevel--
      }
      this.trackEvent('Scout Opponent (View Opponent Stats)', 'Scout Opponent (View Opponent Stats): Button: Scouting Opponent Carousel (Left)')
    },
    next () {
      this.direction = 'next'
      if (this.detailLevel === this.levels.length - 1) {
        this.detailLevel = 0
      } else {
        this.detailLevel++
      }
      this.trackEvent('Scout Opponent (View Opponent Stats)', 'Scout Opponent (View Opponent Stats): Button: Scouting Opponent Carousel (Right)')
    },
    openModal (info) {
      this.modalInfo = info
      this.modalActive = true
      this.detailLevel = info
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/compete/Scouting.js